'use client';;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:native-teams-frontend":true});}catch(e){}}();

import { RootLoading } from '@workspace/ui';
import { resetPostHogUser } from '@workspace/analytics/posthog/client';
import { resetSentryUser } from '@workspace/analytics/sentry/user';
import { useEffect, useRef } from 'react';
import { useAuthStore } from '@/stores/authStore';

interface SessionExpiredResponse {
  redirectTo?: string;
}

function getAuthRedirectUrl(redirectTo?: string): string {
  return redirectTo || process.env.NEXT_PUBLIC_FE_URL_AUTH || '/login';
}

export default function SessionExpiredLogout() {
  const setAccessToken = useAuthStore((s) => s.setAccessToken);
  const setIsAuthenticated = useAuthStore((s) => s.setAuthenticated);
  const setUser = useAuthStore((s) => s.setUser);
  const hasStartedLogout = useRef(false);

  useEffect(() => {
    if (hasStartedLogout.current) return;

    hasStartedLogout.current = true;
    resetPostHogUser();
    resetSentryUser();
    setAccessToken(null);
    setIsAuthenticated(false);
    setUser(null);

    async function clearSessionAndRedirect() {
      try {
        const response = await fetch('/api/auth/session-expired?redirect=false', {
          cache: 'no-store',
        });
        const data = response.ok ? ((await response.json()) as SessionExpiredResponse) : {};

        window.location.replace(getAuthRedirectUrl(data.redirectTo));
      } catch {
        window.location.replace(getAuthRedirectUrl());
      }
    }

    clearSessionAndRedirect();
  }, [setAccessToken, setIsAuthenticated, setUser]);

  return <RootLoading />;
}
